import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Spinner, Button } from '@gsa/afp-component-library';

import AttachmentModal from '../../../../components/Attachment/AttachmentModal';
import { useContractLine } from '../provider/contract-line-provider';

const Modal = ({ url, onClose }) => {
  return (
    <AttachmentModal
      id="image-attachment-preview-modal"
      show
      onClose={onClose}
      hideClose
      variant="large"
      className="contractline-image-attachment-modal"
      actions={
        <Button
          data-testid="attachment-image-modal-close"
          label="Close"
          onClick={onClose}
        />
      }
    >
      <img src={url} alt="Contract line attachment" />
    </AttachmentModal>
  );
};

Modal.propTypes = {
  url: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

const Photo = ({ url, isLoading, scanStatus = 'New', setShowModal }) => {
  const width = 102;
  const height = 66;
  let content = null;
  if (!url && isLoading) {
    content = <Spinner size="small" />;
  }  else if (url) {
    content = (
      <img src={url} alt="Contract attachment" width={width} height={height} />
    );
  }
  return (
    <>
      <div
        role="button"
        tabIndex="0"
        onClick={() => {
          if (url) {
            setShowModal(true);
          }
        }}
        onKeyDown={(e) => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            if (url) {
              setShowModal(true);
            }
          }
        }}
        style={{
          display: 'flex',
          width,
          height: height + 2,
          margin: 8,
          border: `1px solid #A9AEB1`,
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        {content}
      </div>
    </>
  );
};

Photo.propTypes = {
  url: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
};

const PhotoCell = ({ id }) => {
  const { photos, loading } = useContractLine();
  const photo = useMemo(() => photos.find((p) => p.id === id), [photos, id]);
  const imageURL = `${photo?.clAttachmentMetadata?.docStoreUri}/${photo?.name}`;
  const [showModal, setShowModal] = useState(false);


  return (
    <>
      <Photo
        url={imageURL}
        isLoading={loading}
        scanStatus={photo?.clAttachmentMetadata?.scanStatus}
        setShowModal={setShowModal}
      />
      {showModal && (
        <Modal url={imageURL} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

PhotoCell.propTypes = {
  id: PropTypes.string.isRequired,
};

export default PhotoCell;
